import { createContext, useContext } from "react";

// Holds shared, session-level state that multiple layers of the Questions
// component tree need — avoids threading the same values through every
// intermediate component as props.
//
// Values in context:
//   isPaid, general_category_id, category_based_type_id,
//   category_length_type_id, survey_questions, onSurveyAnswerClick, loading,
//   isSelfWrite
//
// The default value is used when a consumer (e.g. Question) is rendered
// outside a QuestionsContext.Provider (e.g. AnotherStoryGeneralCategoryOptions).
const defaultContext = {
  isPaid: false,
  general_category_id: null,
  category_based_type_id: null,
  category_length_type_id: null,
  survey_questions: [],
  onSurveyAnswerClick: () => () => {},
  loading: false,
  isSelfWrite: false,
};

export const QuestionsContext = createContext(defaultContext);

export const useQuestionsContext = () => useContext(QuestionsContext);
